import { apiFetch } from './client.js';

export interface PricingModel {
  model: string;
  in_per_1k: string;
  out_per_1k: string;
  cached_in_per_1k: string;
  source_url: string | null;
  last_checked_at: string | null;
  last_changed_at: string;
  last_check_status: string;
  last_check_note: string | null;
}

export interface PricingAlert {
  kind: 'needs_review' | 'updated' | null;
  note: string | null;
  at: string | null;
}

export interface StaffPricingResponse {
  models: PricingModel[];
  alert: PricingAlert;
}

/** Solo staff Ecosoft. Devuelve 403 al resto. */
export function getStaffPricing(): Promise<StaffPricingResponse> {
  return apiFetch<StaffPricingResponse>('/api/v1/staff/pricing');
}

export function triggerPricingCheck(): Promise<{ ok: boolean; queued: boolean }> {
  return apiFetch('/api/v1/staff/pricing/check', { method: 'POST' });
}
